export default "__VITE_ASSET__4ed1a26d__"